import { DEFAULT_FPS } from '../constants';

/** Milliseconds → frame number */
export function msToFrame(ms: number, fps = DEFAULT_FPS): number {
  return Math.floor((ms / 1000) * fps);
}

/** Frame number → milliseconds */
export function frameToMs(frame: number, fps = DEFAULT_FPS): number {
  return (frame / fps) * 1000;
}

/** Left padding so playhead handle and first ruler label aren't clipped at canvas edge */
const CONTENT_PAD_LEFT = 12;

/** Milliseconds → pixel position on timeline */
export function msToPixel(ms: number, pxPerMs: number, scrollOffsetMs = 0): number {
  return CONTENT_PAD_LEFT + (ms - scrollOffsetMs) * pxPerMs;
}

/** Pixel position → milliseconds */
export function pixelToMs(px: number, pxPerMs: number, scrollOffsetMs = 0): number {
  return (px - CONTENT_PAD_LEFT) / pxPerMs + scrollOffsetMs;
}

/** Milliseconds → "HH:MM:SS:FF" timecode string */
export function msToTimecode(ms: number, fps = DEFAULT_FPS): string {
  const totalSeconds = Math.max(0, ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const frames = Math.floor((totalSeconds % 1) * fps);

  return [
    String(hours).padStart(2, '0'),
    String(minutes).padStart(2, '0'),
    String(seconds).padStart(2, '0'),
    String(frames).padStart(2, '0'),
  ].join(':');
}

/** Format ms as "M:SS" for ruler labels */
export function msToRulerLabel(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
